import { CalendarX2 } from "lucide-react";
import { Button } from "@/modern/components/ui/button-shadcn";
import { CLOCKING_GUIDE_TARGETS, guideTargetProps } from "@/react/guides";

type ClockingEmptyStateProps = {
  exceptionsOnly: boolean;
  onShowAll: () => void;
  onWidenRange: () => void;
};

export function ClockingEmptyState({
  exceptionsOnly,
  onShowAll,
  onWidenRange,
}: ClockingEmptyStateProps) {
  return (
    <div
      className="relative flex h-full min-h-0 flex-col items-center justify-center overflow-hidden px-6"
      {...guideTargetProps(CLOCKING_GUIDE_TARGETS.emptyState)}
    >
      {/* Soft ghost grid — suggests the surface without fake data */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-6 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)",
          backgroundSize: "7rem 3rem",
          maskImage: "radial-gradient(ellipse at center, black 20%, transparent 75%)",
        }}
      />

      <div className="relative z-10 flex max-w-sm flex-col items-center text-center">
        <div className="mb-4 flex size-12 items-center justify-center rounded-2xl border border-border/80 bg-muted/40">
          <CalendarX2 className="size-5 text-muted-foreground" />
        </div>
        <h2 className="text-sm font-semibold text-foreground">Nothing to review</h2>
        <p className="mt-1.5 text-xs leading-relaxed text-muted-foreground">
          {exceptionsOnly
            ? "No exceptions or time off in this range. Clean punches are hidden while Exceptions is on."
            : "No clock records in this date range for this board."}
        </p>
        <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
          {exceptionsOnly ? (
            <Button size="sm" onClick={onShowAll}>
              Show all punches
            </Button>
          ) : null}
          <Button size="sm" variant={exceptionsOnly ? "outline" : "default"} onClick={onWidenRange}>
            Last 14 days
          </Button>
        </div>
      </div>
    </div>
  );
}
